import { BFormGroup, BFormInput, BFormTextarea, BModal } from "bootstrap-vue";

export default {
    name: 'CreateEditAnnouncementsModal',
    components: { BModal, BFormInput, BFormTextarea, BFormGroup },
    props: {
        mode: {
            default: "create",
            type: String,
        },
        value: [Object, String],
    },
    data() {
        return {
            disabled: false,
            url: `admin/announcements`,
            disabledBtn: false,
            announcement: this.value,
        };
    },
    watch: {
        announcement(newVal) {
            this.$emit("input", newVal);
        },
        value(newVal) {
            this.announcement = newVal;
        },
    },
    methods: {
        async submit() {
            this.disabled = true;
            try {
                let formData = new FormData(this.$refs.form);
                console.log(this.announcement,'this.announcement.selectedCustomer');
                
                formData.append("title",this.announcement.title);
                formData.append("description",this.announcement.description);
                
                let response = '';
                if (this.mode == 'create') {
                    formData.append(
                        "customer_id",
                        this.announcement.selectedCustomer != null
                            ? this.announcement.selectedCustomer.id
                            : ""
                    );
                    response = await this.$axios.post(this.url, formData);
                }else{
                    response = await this.$axios.patch(`${this.url}/${this.announcement.id}`, {
                        title: this.announcement.title,
                        description: this.announcement.description,
                        // customer_id: this.announcement.selectedCustomer ? this.announcement.selectedCustomer.id : ""
                    });
                }
                // const response = await this.$axios.post(`admin/announcements/${this.store_id}/change-balance`, formData);
                this.$root.notify(response.data.message, "success");
                const announcements = await this.$axios.get(this.url);
                // console.log(stores.data.data.transactions);
                this.$emit('dataSubmitted', announcements.data.data.announcements);
                this.$root.$emit("bv::hide::modal", "create-edit-announcements-modal");
            } catch (error) {
                this.$root.notify(error);
            }
            this.disabled = false;
        },
    },
};
